import React from "react"

export const ClockIcon = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      width={size * 24}
      height={size * 24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke={color} fill="none" fillRule="evenodd">
        <circle cx="12" cy="12" r="10.846" strokeWidth="2.308" />
        <path strokeWidth="2.5" d="M12 5.95V13l3.676 3.483" />
      </g>
    </svg>
  )
}
